export const categories: string[] = [
  'Educación Inicial',
  'Educación Básica',
  'Educación Media',
  'Educación Elemental',
  'Educación Superior',
  'BGU',
];
